/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 22, height = 22 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.375 15.8C13.4417 15.8 14.35 15.425 15.1 14.675C15.85 13.925 16.225 13.0167 16.225 11.95C16.225 10.8833 15.85 9.975 15.1 9.225C14.35 8.475 13.4417 8.1 12.375 8.1C11.3083 8.1 10.4 8.475 9.65 9.225C8.9 9.975 8.525 10.8833 8.525 11.95C8.525 13.0167 8.9 13.925 9.65 14.675C10.4 15.425 11.3083 15.8 12.375 15.8ZM12.375 14.7C11.6083 14.7 10.9583 14.4333 10.425 13.9C9.89167 13.3667 9.625 12.7167 9.625 11.95C9.625 11.1833 9.89167 10.5333 10.425 10C10.9583 9.46667 11.6083 9.2 12.375 9.2C13.1417 9.2 13.7917 9.46667 14.325 10C14.8583 10.5333 15.125 11.1833 15.125 11.95C15.125 12.7167 14.8583 13.3667 14.325 13.9C13.7917 14.4333 13.1417 14.7 12.375 14.7ZM12.375 18.9C10.1083 18.9 8.04583 18.2625 6.1875 16.9875C4.32917 15.7125 2.93333 14.0333 2 11.95C2.93333 9.86667 4.32917 8.1875 6.1875 6.9125C8.04583 5.6375 10.1083 5 12.375 5C14.6417 5 16.7042 5.6375 18.5625 6.9125C20.4208 8.1875 21.8167 9.86667 22.75 11.95C21.8167 14.0333 20.4208 15.7125 18.5625 16.9875C16.7042 18.2625 14.6417 18.9 12.375 18.9ZM12.375 17.8C14.3583 17.8 16.175 17.2708 17.825 16.2125C19.475 15.1542 20.7333 13.7333 21.6 11.95C20.7333 10.1667 19.475 8.74583 17.825 7.6875C16.175 6.62917 14.3583 6.1 12.375 6.1C10.3917 6.1 8.575 6.62917 6.925 7.6875C5.275 8.74583 4.00833 10.1667 3.125 11.95C4.00833 13.7333 5.275 15.1542 6.925 16.2125C8.575 17.2708 10.3917 17.8 12.375 17.8Z" fill="#262626" />
  </svg>
);

export default SvgComponent;
